"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineStore = void 0;
// 用于断网缓存数据
var storage_1 = require("../utils/storage");
var log_1 = require("../utils/log");
// 单个application限制缓存30条数据
var CACHE_LIMIT = 30;
var OfflineStore = /** @class */ (function () {
    function OfflineStore(app_name, network) {
        this.pending = false;
        try {
            this.storage = new storage_1.MdapStorage({
                name: "mdap_offlinestore_" + app_name
            });
            this.network = network;
        }
        catch (error) {
            // 
        }
    }
    OfflineStore.prototype.setup = function () {
        var _this = this;
        if (!storage_1.supportLocalstorage) {
            return;
        }
        if ('requestIdleCallback' in window) {
            requestIdleCallback(this.checkCache.bind(this));
        }
        else {
            setTimeout(function () {
                _this.checkCache();
            }, 0);
        }
        window.addEventListener('online', function () {
            // check
            _this.checkCache();
        });
    };
    // TODO - 支持custom plugin type, 改造成更灵活的处理 
    OfflineStore.prototype.checkCache = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var keys, dataMap, _i, keys_1, key, data, tag, tag, _d, _e, tag, error_1;
            var _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 5, , 6]);
                        if (this.pending && !storage_1.supportLocalstorage) {
                            return [2 /*return*/];
                        }
                        this.pending = true;
                        keys = (_a = this.storage.getKeys()) !== null && _a !== void 0 ? _a : [];
                        dataMap = {};
                        for (_i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            key = keys_1[_i];
                            data = this.storage.getObject(key);
                            if (!data) {
                                continue;
                            }
                            if (data instanceof Array) {
                                tag = data[0].tag;
                                dataMap[tag] = (_b = data[tag]) !== null && _b !== void 0 ? _b : [];
                                (_f = dataMap[tag]).push.apply(_f, data);
                            }
                            else {
                                tag = data.tag;
                                dataMap[tag] = (_c = data[tag]) !== null && _c !== void 0 ? _c : [];
                                dataMap[tag].push(data);
                            }
                            this.storage.removeItem(key);
                        }
                        _d = 0, _e = Object.keys(dataMap);
                        _g.label = 1;
                    case 1:
                        if (!(_d < _e.length)) return [3 /*break*/, 4];
                        tag = _e[_d];
                        return [4 /*yield*/, this.network.sendBulk({
                                tag: tag,
                                data: dataMap[tag]
                            })];
                    case 2:
                        _g.sent();
                        _g.label = 3;
                    case 3:
                        _d++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.pending = false;
                        return [2 /*return*/, true];
                    case 5:
                        error_1 = _g.sent();
                        this.pending = false;
                        // 失败场景
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    OfflineStore.prototype.checkLimit = function () {
        var _a;
        var keys = (_a = this.storage.getKeys()) !== null && _a !== void 0 ? _a : [];
        if (keys.length < CACHE_LIMIT) {
            return true;
        }
        // 清除旧数据 - 通过key中的timestamp实现排序逻辑
        var sortedKey = keys.sort(function (prev, next) { return prev > next ? -1 : 1; });
        var expiredKeys = sortedKey.slice(CACHE_LIMIT - 1, keys.length);
        for (var _i = 0, expiredKeys_1 = expiredKeys; _i < expiredKeys_1.length; _i++) {
            var key = expiredKeys_1[_i];
            this.storage.removeItem(key);
        }
    };
    OfflineStore.prototype.cacheData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var storeKey;
            return __generator(this, function (_a) {
                if (!storage_1.supportLocalstorage) {
                    return [2 /*return*/];
                }
                try {
                    this.checkLimit();
                    storeKey = "data_" + +new Date();
                    this.storage.setObject(storeKey, data);
                }
                catch (error) {
                    // 
                    log_1.Logger.log('[MDAP] Failed to cache data.');
                }
                return [2 /*return*/];
            });
        });
    };
    return OfflineStore;
}());
exports.OfflineStore = OfflineStore;
